
import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { HomeIcon, LayoutGrid, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

const NotFound = () => {
  // Log 404 errors to track missing pages
  useEffect(() => {
    const logNotFoundError = async () => {
      try {
        const referrer = document.referrer || "direct";
        const path = window.location.pathname;
        
        console.log("Logging 404 error:", { path, referrer });
        
        // Optional: Log 404 errors to Supabase if you want to track them
        // This can be implemented later if needed
        // await supabase.from("error_logs").insert({
        //   error_type: "404",
        //   path,
        //   referrer,
        //   user_agent: navigator.userAgent
        // });
      } catch (error) {
        console.error("Failed to log 404 error:", error);
      }
    };

    logNotFoundError();
  }, []);

  return (
    <div className="min-h-[calc(100vh-64px)] flex flex-col">
      <SEO
        title="Page Not Found | Home Pros OKC"
        description="The page you are looking for does not exist. Return to the Home Pros OKC homepage to find trusted home service professionals in Oklahoma City."
      />
      
      <div className="flex-grow flex items-center justify-center px-4 py-12">
        <div className="max-w-lg w-full text-center">
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-[#174996]">404</h1>
            <div className="w-16 h-1 bg-[#174996] mx-auto mt-2 mb-6"></div>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Oops! Looks like you took a wrong turn.
            </h2>
            <p className="text-gray-600 mb-8">
              The page you're looking for doesn't exist or may have been moved.
              Let us help you find your way back.
            </p>
          </div>

          <div className="space-y-4">
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild className="flex items-center gap-2 bg-[#174996] hover:bg-[#0d3370]">
                <Link to="/">
                  <HomeIcon className="h-4 w-4" />
                  <span>Return to Homepage</span>
                </Link>
              </Button>
              
              <Button asChild variant="outline" className="flex items-center gap-2 border-[#174996] text-[#174996]">
                <Link to="/services">
                  <LayoutGrid className="h-4 w-4" />
                  <span>Browse Services</span>
                </Link>
              </Button>
            </div>
            
            <div className="pt-2">
              <Button 
                variant="link" 
                className="text-[#174996]"
                onClick={() => window.history.back()}
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Go Back to Previous Page
              </Button>
            </div>
          </div>
          
          <div className="mt-12">
            <h3 className="text-lg font-medium text-gray-800 mb-4">
              Popular Services
            </h3>
            <div className="flex flex-wrap justify-center gap-3">
              <Link to="/best-plumbers-oklahoma-city" className="text-sm px-3 py-1 bg-[#D3E4FD] text-[#174996] rounded-full hover:bg-[#b3d0fa]">
                Plumbing
              </Link>
              <Link to="/best-electricians-oklahoma-city" className="text-sm px-3 py-1 bg-[#D3E4FD] text-[#174996] rounded-full hover:bg-[#b3d0fa]">
                Electrical
              </Link>
              <Link to="/best-hvac-contractors-oklahoma-city" className="text-sm px-3 py-1 bg-[#D3E4FD] text-[#174996] rounded-full hover:bg-[#b3d0fa]">
                HVAC
              </Link>
              <Link to="/best-roofers-oklahoma-city" className="text-sm px-3 py-1 bg-[#D3E4FD] text-[#174996] rounded-full hover:bg-[#b3d0fa]">
                Roofing
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
